// extracted by mini-css-extract-plugin
module.exports = {"chartAxisG":"p6po5TEe"};